<template>
  <v-dialog
    :value="dialog"
    :max-width="width"
    :retain-focus="false"
    @keydown.esc="close"
    @keydown.enter="close"
    @click:outside="close"
  >
    <v-card
      :class="{ 'pt-2': !attrs.title }"
      outlined
    >
      <template v-if="attrs.title">
        <v-card-title
          v-html="attrs.title"
          class="py-2"
        ></v-card-title>
        <v-divider></v-divider>
      </template>
      <v-card-text
        v-html="message"
        class="py-4 body-1 text--primary"
      ></v-card-text>
      <v-card-actions class="justify-center pb-4">
        <v-btn
          :color="btnColor"
          depressed
          @click.stop.prevent="close"
        >
          {{ btnText || $t('components.alert.btnText') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { VDialog, VBtn, VCard, VCardTitle, VCardText, VCardActions } from 'vuetify/lib'


export default {
  components: {
    VDialog,
    VBtn,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions
  },


  props: {
    type: {
      type: String
    },
    btnText: {
      type: String
    },
    btnColor: {
      type: String,
      default: 'primary'
    },
    title: {
      type: String
    },
    message: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 400
    }
  },


  data () {
    return {
      dialog: true,
      presets: {
        error: {
          title: this.$t('components.alert.error')
        }
      }
    }
  },


  computed: {
    attrs () {
      const defaultAttrs = this.presets[this.type] || {}

      const attrs = {
        title: this.title || defaultAttrs.title
      }

      return attrs
    }
  },


  methods: {
    close () {
      this.dialog = false
      this.$destroy()
    }
  }
}
</script>
